export const PREPARE_FOR_QUICK_QUOTE = 'PREPARE_FOR_QUICK_QUOTE'

export const prepareQuickQuote = (biType, productCategory) => ({
  type: PREPARE_FOR_QUICK_QUOTE,
  payload: { biType, productCategory },
})

export const SHARE_QUICK_QUOTE = 'SHARE_QUICK_QUOTE'

export const shareQuickQuote = (category, biType) => ({
  type: SHARE_QUICK_QUOTE,
  payload: {
    category,
    biType,
  },
})

export const PREPARE_FOR_RPQ = 'PREPARE_FOR_RPQ'

export const PREPARE_FOR_RA = 'PREPARE_FOR_RA'

export const prepareRA = () => ({
  type: PREPARE_FOR_RA,
  payload: {},
})

export const prepareRPQ = () => ({
  type: PREPARE_FOR_RPQ,
  payload: {},
})

export const SHARE_RPQ = 'SHARE_RPQ'

export const shareRPQ = () => ({
  type: SHARE_RPQ,
  payload: {},
})

export const SHARE_RA = 'SHARE_RA'
export const shareRA = () => ({
  type: SHARE_RA,
  payload: {},
})
